import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const RouterTab = ({ children, disabled, isActive, onTabClick, path }) => (
  <button
    disabled={disabled}
    className={classNames('router-tab', { 'is-active': isActive })}
    onClick={() => onTabClick(path)}
  >
    {children}
  </button>
);

RouterTab.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onTabClick: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
};

export default RouterTab;
